import { Helmet } from 'react-helmet-async';
import React from 'react';
import PropTypes from 'prop-types';
import { getStationDescription } from '../../../lib/utils/generateStationSchema';
import AmenityPropType from '../../prop-types/amenity';
import FuelPropType from '../../prop-types/fuel';
import ReviewPropType from '../../prop-types/review';


export const StationHelmet = ({ station, reviews, fuels, amenities }) => {
  const { address, brandings, name } = station;
  const stationTitle = [name, address.line_1, [address.locality, address.region].join(', '), 'GasBuddy.com'].join(' - ');

  const stationDescription = getStationDescription(station, reviews, fuels, amenities);
  const brandId = brandings ? brandings[0]?.brand_id : station.brand_id || 0;

  return (
    <Helmet>
      <title>{stationTitle}</title>
      <meta name="description" content={stationDescription} />
      <meta property="og:title" content={stationTitle} />
      <meta property="og:image" content={`https://images.gasbuddy.com/di/b/1/${brandId}.png?w=256`} />
      <meta property="og:description" content={stationDescription} />
      <meta name="twitter:title" content={stationTitle} />
      <meta name="twitter:image" content={`https://images.gasbuddy.com/di/b/1/${brandId}.png?w=256`} />
      <meta name="twitter:description" content={stationDescription} />
    </Helmet>
  );
};

StationHelmet.propTypes = {
  station: PropTypes.string,
  reviews: PropTypes.arrayOf(ReviewPropType),
  fuels: PropTypes.arrayOf(FuelPropType),
  amenities: PropTypes.arrayOf(AmenityPropType),
};

StationHelmet.defaultProps = {
  station: '',
  reviews: [],
  fuels: [],
  amenities: [],
};

export default StationHelmet;
